import CustomForm from "@components/global/CustomForm";
import { ErrorType } from "@components/global/new/Error/Error";
import { RecordResponse, RecordsResponse } from "@services/http/responses/BaseResponse";
import useApiRequests from "@services/http/useApiRequest";
import { useState } from "react";
import { UploadFile, UploadProps } from "antd/es/upload";
import { CreateSparePartsType, ISparePartType, UploadSparePartTypeImage } from "../../SpareParts.http";

export type AddSparePartsTypesOnSuccess = (value: ISparePartType) => void;

export default function useAddSparePartsTypesModalControl(
  onSuccess: AddSparePartsTypesOnSuccess,
  handleClose: () => void,
) {

  const requests = useApiRequests();
  const [errors, setErrors] = useState<ErrorType>();
  const [files, setFiles] = useState<UploadFile[]>([]);
  const [isLoading, setLoading] = useState(false);

  async function submit(e: React.FormEvent<CustomForm>) {
    e.preventDefault();
    try {
      setLoading(true);
      const elements = e.currentTarget.elements;
      const name = elements.namedItem("name") as HTMLInputElement;
      if (!name.value) {
        setErrors({ fill: true });
      }
      const response = await requests.enqueueSilent<RecordsResponse<number>>(
        new CreateSparePartsType(0, name.value)
      );
      if (response && response.Status === "success") {
        const typeId = response.Records[0];
        let imageUrl = '';

        if (typeId && files.length > 0) {
          const file = files[0].originFileObj as Blob;
          const result = await requests.enqueueSilent<RecordResponse<string>>(
            new UploadSparePartTypeImage(typeId, file)
          );
          if (result && result.Record) {
            imageUrl = result.Record;
          }
        }
        onSuccess({
          Id: typeId,
          Name: name.value,
          Total: 0,
          Pic: imageUrl
        } as ISparePartType);
        handleClose();
      }
    } catch {

    } finally {
      setLoading(false);
    }
  }

  const [previewOpen, setPreviewOpen] = useState(false);
  const [previewImage, setPreviewImage] = useState('');

  const getBase64 = (file: Blob): Promise<string> =>
    new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        console.log("Onload", reader);
        resolve(reader.result as string);
      }
      reader.onerror = (error) => reject(error);
    });

  async function handlePreview(file: UploadFile) {
    const preview = await getBase64(file.originFileObj as Blob);
    console.log("Before preview", preview);
    setPreviewImage(preview);
    setPreviewOpen(true);
  }

  return {
    errors,
    isLoading,
    files,
    previewImage,
    previewOpen,
    setPreviewOpen,
    setPreviewImage,
    handlePreview,
    setFiles,
    submit,
  }
}